/*
 * @Author: 小周
 * @Date: 2024-08-01 10:52:02
 * @LastEditTime: 2024-08-02 16:30:59
 * @LastEditors: MrZHLF
 * @Description:
 */
import { getUser } from '@/utils/userStore'
import { isCheckApp, getBrowserEnvironment } from '@/utils/index'
import Cookies from 'js-cookie'
import { TRACK_H5_PROJECT_NAME, ARTICLE_ID } from '@/constant/index'

const useViewDxTrack = async (track) => {
  var sensors = window['sensorsDataAnalytic201505']
  let isDxAPP = await isCheckApp() //环境判断
  let userInfo =
    getUser() ||
    (Cookies.get('realUserInfo')
      ? JSON.parse(Cookies.get('realUserInfo'))
      : null) //获取用户信息
  const user = Cookies.get('userInfo')
    ? JSON.parse(Cookies.get('userInfo'))
    : null
  let userId = '' //获取用户信息
  if (userInfo && userInfo.userId) {
    userId = userInfo.userId
  } else if (userInfo && userInfo.id) {
    userId = userInfo.id
  } else if (user && user.dxUserId) {
    userId = user.dxUserId
  } else {
    userId = ''
  }
  sensors.init({
    sdk_url: 'https://res.hntv.tv/lib/sensorsdata/sensorsdata.min.js',
    name: 'sensors',
    server_url: `${process.env.REACT_APP_TRACK_URL}/behavior/sa.gif?token=1427918398613422082&project=hntv&clientId=bd4859dcd7b141eeb297e2f6b6333cec`,
    show_log: false,
    heatmap: {
      clickmap: 'default',
      scroll_notice_map: 'default',
      collect_url: true,
      collect_input: false,
      element_selector: 'not_use_id',
    },
  })
  if (isDxAPP) {
    // 文稿浏览统计
    sensors.track('ViewH5', {
      h5Project: TRACK_H5_PROJECT_NAME,
      articleId: ARTICLE_ID, //稿件ID
      userIdDX: userId,
      inApp: isDxAPP ? 'Y' : 'N',
      unionId: user?.unionId ? user?.unionId : '',
      dxAccountId: user?.dxAccountId ? user?.dxAccountId : '',
      platform: getBrowserEnvironment(),
      tenantId: 1, //租户id
      ip: '', //经纬度或ip
      time: '', //事件发生时间
    })
  } else {
    // H5环境埋对象埋点
    sensors.track('ViewArticle', {
      articleId: ARTICLE_ID,
      inApp: isDxAPP ? 'Y' : 'N',
      userIdDX: userId,
      channelId: track && track.channelId,
      articleType: track && track.articleType,
      unionId: user?.unionId ? user?.unionId : '',
      dxAccountId: user?.dxAccountId ? user?.dxAccountId : '',
      platform: getBrowserEnvironment(),
    })
    sensors.track('ViewH5', {
      h5Project: TRACK_H5_PROJECT_NAME,
      articleId: ARTICLE_ID, //稿件ID
      userIdDX: userId,
      inApp: isDxAPP ? 'Y' : 'N',
      unionId: user?.unionId ? user?.unionId : '',
      dxAccountId: user?.dxAccountId ? user?.dxAccountId : '',
      platform: getBrowserEnvironment(),
      tenantId: 1, //租户id
      ip: '', //经纬度或ip
      time: '', //事件发生时间
    })
  }
}

export default useViewDxTrack
